import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import musicTitle from '../../asset/music/sein.mp3'

const YuSeIn2 = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "황병석 💜 유세인 결혼합니다.";
    const openDesc = "8월 23일 오후 3시, THE LINK";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/274/thumb.jpg";

    const lng = 126.883956501896;
    const lat = 37.5054782085179;

    const placeTelNum = "02-852-5000";

    const forCar = "네비게이션에 '더링크호텔 서울' 또는 \n'서울 구로구 경인로 610' 입력"
    const forSubway = "1, 2호선 [신도림역] 1번 출구, 도보 12분 \n(1번 출구 건너편 홈플러스 앞 셔틀버스 상시운행) \n\n 1호선 [구로역] 3번 출구, 도보 7분"
    const forParking = "주차 1시간 30분 무료 (초과시 15분당 1,000원)\n* 주차장이 혼잡하오니 가급적 대중교통 이용을 부탁\n드립니다."
    const forBus = "신도림동(구로역)하차\n10, 11-1, 11-2, 83, 88, 530, 160, 503, 600, 660, \n662, 301, 320, 5200\n\n신도림중학교 하차\n615, 5714, 6512, 6411, 6511"
    const forShuttleBus = "셔틀버스 신도림역 1번 출구에서 탑승(주기적으로 운행)"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 찐 남색 블루
        concept: "SUMMER",
        titleColor: "#191870",
        pointColor: "#191870",
        btnBgColor: "#191870",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }
    // const conceptStyle = {
    //     // summer 올리브
    //     concept: "SUMMER",
    //     titleColor: "#405200",
    //     pointColor: "#405200",
    //     btnBgColor: "#405200",
    //     fontColor: "#fff",
    //     btnFontColor: "#fff",
    //     chatBgColor: "#F5F8FF",
    //     fontFamilyKo: "SCDream3",
    //     fontFamilyEn: "Edensor"
    // }

    const title = "저희 결혼합니다."

    const msg1 = "낯선 곳에서 작은 부딪힘으로 시작한 우리의 첫 만남,";
    const msg2 = "어쩌면 모르고 지나쳤을 당신이지만\n이제는 부부로서의 당신으로 마주하려합니다.";
    const msg3 = "2025년 8월 23일,\n애정어린 마음으로 축복해주신다면\n더없는 사랑으로 보답하며 살아가겠습니다.";

    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "황병석",
            bank: "카카오뱅크",
            accountNumber : "3333-20-9370694",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FWbZy3kA0"
        }
        ,{
            role: "신랑 모·부",
            name: "윤효주(황윤기)",
            bank: "우리은행",
            accountNumber : "1002-654-245238",
            isKakao : false
        }
        // ,{
        //     role: "신랑 모",
        //     name: "김병순",
        //     bank: "우리은행",
        //     accountNumber : "1002-444-657162",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "유세인",
            bank: "국민은행",
            accountNumber : "479402-04-345981",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7r8vBjL"
        }
        ,{
            role: "신부 부",
            name: "유승배",
            bank: "농협",
            accountNumber : "441-12-299961",
            isKakao : false
        }
        // ,{
        //     role: "신부 모",
        //     name: "김다연",
        //     bank: "우리은행",
        //     accountNumber : "1002-929-183666",
        //     isKakao : false
        // }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "데스티니~",
            brideAnswer: "복도어깨빵"
        },
        {
            question : "솔직히 우리 그때 서로 반한거같아, 그치?",
            groomAnswer: "그렇고말고",
            brideAnswer: "존잘연하남"
        },
        {
            question : "이제 우리 부부되는데 소감이 어때?",
            groomAnswer: "꿈인지생신지",
            brideAnswer: "쀼의세계로"
        },
        {
            question : "결혼준비하며 고생한 서로에게 한마디씩 해보자!",
            groomAnswer: "고생많았어",
            brideAnswer: "진짜나고생함"
        },
        {
            question : "앞으로의 결혼생활의 다짐을 5글자로!",
            groomAnswer: "쭉 행복하자",
            brideAnswer: "요리킹내조킹"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이상현",
            call: "010-5048-1259"
        }
        ,{
            role: "신랑 부",
            name: "이용우",
            call: "010-4103-1248"
        }
        ,{
            role: "신랑 모",
            name: "이영실",
            call: "010-7137-1248"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "조아인",
            call: "010-6389-6551"
        }
        ,{
            role: "신부 부",
            name: "조양주",
            call: "010-3789-6551"
        }
        ,{
            role: "신부 모",
            name: "박은영",
            call: "010-9040-6551"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
        // #3640b3
      //   #3c20a1
      // #25146e
      // #182C4F
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#191870"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.groomNameEn)} brideNameEn={getRemoveSpaceName(weddingData.brideNameEn)} color={"#1a499c"} letteringFontColor={"#191870"} dateColor={"#1a499c"} bottom={"31%"} bottom2={"22.2%"} dateBottom={"1%"} top={"3%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"10px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.groomName)} groomName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forParking={forParking} forShuttleBus={forShuttleBus} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default YuSeIn2;